{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2018 - 2024                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.Login;

{$DEFINE NOPP}

interface

uses
  Classes, SysUtils, Types, WEBLib.Controls, WEBLib.StdCtrls, WEBLib.Graphics, WEBLib.Dialogs,
  Web;

type
  TLoginPanel = class(TCustomControl)
  private
    FPasswordLabel: string;
    FOnLogin: TNotifyEvent;
    FUserLabel: string;
    FPassword: string;
    FCaptionLabel: string;
    FUser: string;
    FBorderColor: TColor;
    FLoginLabel: string;
    FElementButtonClassname: string;
    FElementInputClassName: string;
    FElementClassName: string;
    FUserInput: TJSHTMLElement;
    FPasswordInput: TJSHTMLElement;
    FUserLabelSpan: TJSHTMLElement;
    FPasswordLabelSpan: TJSHTMLElement;
    FButton: TJSHTMLElement;
    FCaption: TJSHTMLElement;
    FElementCaptionClassName: string;
    FPadding: integer;
    FMargin: integer;
    FElementLabelClassName: string;
    FCreated: boolean;
    procedure SetPassword(const Value: string);
    procedure SetPasswordLabel(const Value: string);
    procedure SetUser(const Value: string);
    procedure SetUserLabel(const Value: string);
    function HandleLoginClick(Event: TJSMouseEvent): Boolean; virtual;
    function HandlePasswordKeypress(Event: TJSKeyBoardEvent): Boolean; virtual;
    function GetPassword: string;
    function GetUser: string;
    procedure SetBorderColor(const Value: TColor); reintroduce;
    procedure SetCaptionLabel(const Value: string);
    procedure SetElementButtonClassName(const Value: string);
    procedure SetElementCaptionClassName(const Value: string);
    procedure SetElementClassName(const Value: string); reintroduce;
    procedure SetElementInputClassName(const Value: string);
    procedure SetMargin(const Value: integer);
    procedure SetPadding(const Value: integer);
    procedure SetElementLabelClassName(const Value: string);
    procedure SetLoginLabel(const Value: string);
  protected
    procedure DoLogin; virtual;
    function CreateElement: TJSElement; override;
    procedure UpdateElementVisual; override;
    procedure UpdateElementData; override;
    procedure BindEvents; override;
    procedure UnbindEvents; override;
  public
    procedure CreateInitialize; override;
  published
    property Align;
    property AlignWithMargins;
    property Anchors;
    property BorderColor: TColor read FBorderColor write SetBorderColor;
    property CaptionLabel: string read FCaptionLabel write SetCaptionLabel;
    property Center;
    property ElementClassName: string read FElementClassName write SetElementClassName;
    property ElementFont;
    property ElementID;
    property ElementPosition;
    property ElementCaptionClassName: string read FElementCaptionClassName write SetElementCaptionClassName;
    property ElementInputClassName: string read FElementInputClassName write SetElementInputClassName;
    property ElementButtonClassName: string read FElementButtonClassName write SetElementButtonClassName;
    property ElementLabelClassName: string read FElementLabelClassName write SetElementLabelClassName;
    property Font;
    property LoginLabel: string read FLoginLabel write SetLoginLabel;
    property Margin: integer read FMargin write SetMargin;
    property Padding: integer read FPadding write SetPadding;
    property Password: string read GetPassword write SetPassword;
    property PasswordLabel: string read FPasswordLabel write SetPasswordLabel;
    property User: string read GetUser write SetUser;
    property UserLabel: string read FUserLabel write SetUserLabel;
    property OnClick;
    property OnLogin: TNotifyEvent read FOnLogin write FOnLogin;

  end;

  TWebLoginPanel = class(TLoginPanel);

implementation

{ TLoginPanel }

procedure TLoginPanel.BindEvents;
var
  s: string;
begin
  inherited;

  if FCreated then
  begin
    FButton.addEventListener('click', @HandleLoginClick);
    FPasswordInput.addEventListener('keypress', @HandlePasswordKeypress);
    FCreated := false;
  end
  else
  begin
    s := GetID + '_btn';
    FButton := TJSHTMLElement(document.getElementById(s));
    FButton.addEventListener('click', @HandleLoginClick);

    s := GetID + '_usr';
    FUserInput := TJSHTMLElement(document.getElementById(s));
    s := GetID + '_pwd';
    FPasswordInput := TJSHTMLElement(document.getElementById(s));
    FPasswordInput.addEventListener('keypress', @HandlePasswordKeypress);
  end;
end;

function TLoginPanel.CreateElement: TJSElement;
var
  br: TJSElement;
  useCSS: boolean;
begin
  FCreated := true;
  Result := document.createElement('SPAN');

  FCaption := TJSHTMLElement(document.createElement('DIV'));

  FUserInput := TJSHTMLElement(document.createElement('INPUT'));
  FUserInput['id'] := Name + '_usr';
  FPasswordInput := TJSHTMLElement(document.createElement('INPUT'));
  FPasswordInput.setAttribute('type','password');
  FPasswordInput['id'] := Name + '_pwd';

  FUserLabelSpan := TJSHTMLElement(document.createElement('DIV'));
  FPasswordLabelSpan := TJSHTMLElement(document.createElement('DIV'));

  useCSS := UseCSSFont;

  SetHTMLElementFont(FCaption, Font, useCSS);
  SetHTMLElementFont(FUserLabelSpan, Font, useCSS);
  SetHTMLElementFont(FUserInput, Font, useCSS);
  SetHTMLElementFont(FPasswordLabelSpan, Font, useCSS);
  SetHTMLElementFont(FPasswordInput, Font, useCSS);

  Result.appendChild(FCaption);
  Result.appendChild(FUserLabelSpan);
  Result.appendChild(FUserInput);
  Result.appendChild(FPasswordLabelSpan);
  Result.appendChild(FPasswordInput);

  br := document.createElement('BR');
  Result.appendChild(br);

  FButton := TJSHTMLElement(document.createElement('BUTTON'));
  FButton['id'] := Name + '_btn';
  Result.appendChild(FButton);
end;

procedure TLoginPanel.CreateInitialize;
begin
  inherited;
  Color := clInfoBk;
  FCaptionLabel := 'Login';
  FBorderColor := clSilver;
  FUserLabel := 'Username:';
  FPasswordLabel := 'Password:';
  FLoginLabel := 'Login';
  FPadding := 10;
  FMargin := 5;
  Height := 155;
  Width := 185;
end;

procedure TLoginPanel.DoLogin;
begin
  if Assigned(OnLogin) then
    OnLogin(Self);
end;

function TLoginPanel.GetPassword: string;
begin
  if Assigned(FPasswordInput) then
    Result := (FPasswordInput as TJSHTMLInputElement).value
  else
    Result := FPassword;
end;

function TLoginPanel.GetUser: string;
begin
  if Assigned(FUserInput) then
    Result := (FUserInput as TJSHTMLInputElement).value
  else
    Result := FUser;
end;

function TLoginPanel.HandleLoginClick(Event: TJSMouseEvent): Boolean;
begin
  Result := true;
  DoLogin;
end;

function TLoginPanel.HandlePasswordKeypress(Event: TJSKeyBoardEvent): Boolean;
begin
  Result := true;
  if (Event.Key = 'Enter') then
    DoLogin;
end;

procedure TLoginPanel.SetBorderColor(const Value: TColor);
begin
  if (FBorderColor <> Value) then
  begin
    FBorderColor := Value;
    UpdateElementVisual;
  end;
end;

procedure TLoginPanel.SetCaptionLabel(const Value: string);
begin
  if (FCaptionLabel <> Value) then
  begin
    FCaptionLabel := Value;
    UpdateElementData;
  end;
end;

procedure TLoginPanel.SetElementButtonClassName(const Value: string);
begin
  FElementButtonClassname := Value;
end;

procedure TLoginPanel.SetElementCaptionClassName(const Value: string);
begin
  FElementCaptionClassName := Value;
end;

procedure TLoginPanel.SetElementClassName(const Value: string);
begin
  FElementClassName := Value;
end;

procedure TLoginPanel.SetElementInputClassName(const Value: string);
begin
  FElementInputClassName := Value;
end;

procedure TLoginPanel.SetElementLabelClassName(const Value: string);
begin
  if (FElementLabelClassName <> Value) then
  begin
    FElementLabelClassName := Value;
    UpdateElementVisual;
  end;
end;

procedure TLoginPanel.SetLoginLabel(const Value: string);
begin
  if FLoginLabel <> Value then
  begin
    FLoginLabel := Value;
    UpdateElementData;
  end;
end;

procedure TLoginPanel.SetMargin(const Value: integer);
begin
  if (FMargin <> Value) then
  begin
    FMargin := Value;
    UpdateElementVisual;
  end;
end;

procedure TLoginPanel.SetPadding(const Value: integer);
begin
  if (FPadding <> Value) then
  begin
    FPadding := Value;
    UpdateElementVisual;
  end;
end;

procedure TLoginPanel.SetPassword(const Value: string);
begin
  if (FPassword <> Value) then
  begin
    FPassword := Value;
    UpdateElementData;
  end;
end;

procedure TLoginPanel.SetPasswordLabel(const Value: string);
begin
  if (FPasswordLabel <> Value) then
  begin
    FPasswordLabel := Value;
    UpdateElementData;
  end;
end;

procedure TLoginPanel.SetUser(const Value: string);
begin
  if (FUser <> Value) then
  begin
    FUser := Value;
    UpdateElementData;
  end;
end;

procedure TLoginPanel.SetUserLabel(const Value: string);
begin
  if (FUserLabel <> Value) then
  begin
    FUserLabel := Value;
    UpdateElementData;
  end;
end;

procedure TLoginPanel.UnbindEvents;
begin
  inherited;
  FButton.removeEventListener('click',@HandleLoginClick);
end;

procedure TLoginPanel.UpdateElementData;
begin
  inherited;
  FUserLabelSpan.innerHTML := FUserLabel;
  FPasswordLabelSpan.innerHTML := FPasswordLabel;
  FButton.innerHTML := FLoginLabel;
  FCaption.innerHTML := FCaptionLabel;
  (FUserInput as TJSHTMLInputElement).value := FUser;
  (FPasswordInput as TJSHTMLInputElement).value := FPassword;
end;

procedure TLoginPanel.UpdateElementVisual;
var
  strpadding,strmargin: string;
  useCSS: boolean;
begin
  inherited;

  if Assigned(ElementHandle) then
  begin
    useCSS := UseCSSFont;

    strpadding := IntToStr(Padding)+'px';
    strmargin := IntToStr(Margin)+'px';

    ElementHandle.setAttribute('class',ElementClassName);

    if (ElementClassName = '') then
    begin
      ElementHandle.style.setProperty('border', 'solid 1px '+ColorToHTML(BorderColor));
      ElementHandle.style.setProperty('padding',strPadding);
    end;

    if Visible then
      ElementHandle.style.setProperty('display','table');

    FCaption.setAttribute('class',ElementCaptionClassName);

    if (ElementCaptionClassName = '') then
    begin
      FCaption.style.setProperty('margin-top',strMargin);
      FCaption.style.setProperty('margin-bottom',strMargin);
      FCaption.style.setProperty('font-weight','bold');

      SetHTMLElementFont(FCaption, Font, useCSS);
    end;

    FUserInput.setAttribute('class',ElementInputClassName);
    FPasswordInput.setAttribute('class',ElementInputClassName);

    if (ElementInputClassName = '') then
    begin
      FUserInput.style.setProperty('margin-top',strMargin);
      FUserInput.style.setProperty('margin-bottom',strMargin);
      FPasswordInput.style.setProperty('margin-top',strMargin);
      FPasswordInput.style.setProperty('margin-bottom',strMargin);

      SetHTMLElementFont(FUserInput, Font, useCSS);
      SetHTMLElementFont(FPasswordInput, Font, useCSS);
    end;

    FUserInput.style.setProperty('width','100%');
    FUserInput.style.setProperty('display','table-cell');

    FPasswordInput.style.setProperty('width','100%');
    FPasswordInput.style.setProperty('display','table-cell');

    FUserLabelSpan.setAttribute('class',ElementLabelClassName);
    FPasswordLabelSpan.setAttribute('class',ElementLabelClassName);

    if (ElementLabelClassName = '') then
    begin
      FUserLabelSpan.style.setProperty('margin-top',strMargin);
      FUserLabelSpan.style.setProperty('margin-bottom',strMargin);
      FPasswordLabelSpan.style.setProperty('margin-top',strMargin);
      FPasswordLabelSpan.style.setProperty('margin-bottom',strMargin);

      SetHTMLElementFont(FUserLabelSpan, Font, useCSS);
      SetHTMLElementFont(FPasswordLabelSpan, Font, useCSS);
    end;

    FButton.setAttribute('class',ElementButtonClassName);

    if (ElementButtonClassname = '') then
    begin
      FButton.style.setProperty('margin-top',strMargin);
      FButton.style.setProperty('margin-bottom',strMargin);

      SetHTMLElementFont(FButton, Font, useCSS);
    end;

    FButton.style.setProperty('float','right');
  end;
end;

end.
